import React, { Component } from 'react';

class Aside extends Component{
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        document.addEventListener('mouseup', (event) => {
            if(this.draggable === true) {
                const offsetX = this.stopOffset[0]- this.startOffset[0];
                const offsetY = this.stopOffset[1]- this.startOffset[1];

                this.props.onMenuDragStop([this.props.Offset[0] + offsetX, 0]);
            }

            this.draggable = false;
        }, false);

        document.addEventListener('mousemove', (event) => {
            if(this.draggable === true) {
                this.stopOffset = [event.pageX, event.pageY]
                const offsetX = this.stopOffset[0]- this.startOffset[0];
                const offsetY = this.stopOffset[1]- this.startOffset[1];

                const draggable = this.refs.draggable;

                draggable.style.left = (this.props.Offset[0] + offsetX - 6) + 'px';

            }
        }, false);
    }

    onMenuDraggable(x, y) {
        this.draggable = true;
        
        this.startOffset = [x, y];
        this.stopOffset = [x, y];

        this.props.onMenuDragStart();
    }

    render() {
        const { children } = this.props;
        return (
            <div className="root-aside"  style={{width: this.props.Offset[0]}} >
                <div className="root-tree">
                    {children}
                </div>
                <div className="root-draggable"
                onMouseDown={(event) => {
                    this.onMenuDraggable(event.pageX, event.pageY)
                }} ref="draggable">
                    <i></i>
                </div>
            </div>
        )
    }
}

export default Aside;